import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetListOutcomes state domain
 */

const selectWidgetListOutcomesDomain = (state) =>
  state.get("widgetListOutcomes", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectWidgetListOutcomesDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectDimensionsOutcomes = () =>
  createSelector(selectWidgetListOutcomesDomain, (state) =>
    state.get("dimensionsOutcomes")
  )

const makeSelectWidgetListOutcomes = () =>
  createSelector(selectWidgetListOutcomesDomain, (substate) => substate.toJS())

export default makeSelectWidgetListOutcomes
export { selectWidgetListOutcomesDomain }
